import { ProcessStatus } from '../types/process-status';

export class BodyProcessStatus {
  processStatus: ProcessStatus;
  progressComment: string | null;

  constructor(status: ProcessStatus, progressComment: string | null) {
    this.processStatus = status;
    this.progressComment = progressComment;
  }
}
